import { Container, SliceBorder, Title } from "../../shared/ui";

import { about } from "./consts/about";

import styles from "./AboutMain.module.scss";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";

export const AboutMain = () => {
    const isTablet = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.lg));
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));

    const sliceRadius = () => {
        if (isMobile) {
            return 12;
        }
        if (isTablet) {
            return 25;
        }
        return 32;
    };

    return (
        <Container className={styles.aboutMain}>
            <div className={styles.aboutMain__wrapperImg}>
                <img className={styles.aboutMain__img} src={about.img} alt="Почувствуйте энегрию лидерства" />
                <SliceBorder
                    sizeRadius={sliceRadius()}
                    className={styles.aboutMain__wrapperTitle}
                    border={{
                        bottomRight: "inside",
                        topRight: "outside-corner-lateral",
                        bottomLeft: "outside-corner-upper",
                    }}
                >
                    <Title className={styles.aboutMain__title} level={1}>
                        Почувствуйте энергию лидерства
                    </Title>
                </SliceBorder>
            </div>
        </Container>
    );
};
